import {
    CREATE_DATA_COLLECTION_PERSONALITY_TEST_V2,
    SAVE_ANSWER_FOR_PERSONALITY_TEST_V2,
    SKIP_QUESTION_FOR_PERSONALITY_TEST_V2
} from '@/api/personalityTests/mutations';
import {DocumentNode, OperationDefinitionNode} from 'graphql';
import {
    LocalConfig,
    LocalConfigWithStagingBackend,
    ProductionConfig,
    StagingConfig
} from '../secrets/config_constants';

export type Config =
    | typeof LocalConfig
    | typeof LocalConfigWithStagingBackend
    | typeof StagingConfig
    | typeof ProductionConfig;

function isStaging() {
    return window.location.hostname.includes('staging.app.alvalabs.io');
}

function isLocal() {
    return (
        window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'
    );
}

function isLocalPreview() {
    return window.location.host === 'localhost:4173';
}

function isProduction() {
    return window.location.hostname.includes('app.alvalabs.io');
}

export function isGHPages() {
    return window.location.hostname.includes('alvalabs.github.io');
}

export function shouldUseStagingBackendForDev(): boolean {
    if (isLocalPreview()) {
        return true;
    }
    if (!isLocal() || typeof process === 'undefined') {
        return false;
    }
    return process?.env?.VITE_USE_STAGING_BACKEND === 'true';
}

export const getConfig = (): Config => {
    if (isStaging()) {
        return StagingConfig;
    }
    if (isProduction()) {
        return ProductionConfig;
    }
    if (isLocal()) {
        return shouldUseStagingBackendForDev() ? LocalConfigWithStagingBackend : LocalConfig;
    }
    return StagingConfig;
};

export function getBaseUrl() {
    return getConfig().BACKEND;
}

export const graphqlEndpoint = getBaseUrl() + '/graphql';
// Language config
export const DEFAULT_LOCALE = 'en';

function getOperationName(gql: DocumentNode): string | null {
    const operationDefinition = gql.definitions.find(
        def => def.kind === 'OperationDefinition'
    ) as OperationDefinitionNode;

    return operationDefinition && operationDefinition.name
        ? operationDefinition.name.value
        : null;
}

export const IDEMPOTENT_MUTATIONS = [
    getOperationName(SAVE_ANSWER_FOR_PERSONALITY_TEST_V2),
    getOperationName(SKIP_QUESTION_FOR_PERSONALITY_TEST_V2),
    getOperationName(CREATE_DATA_COLLECTION_PERSONALITY_TEST_V2)
];
